import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from '../modules/history';
import RoutePrivate from '../components/RoutePrivate';
import User from './User';
import UserDetail from './User/UserDetail';
import Card from './Card';
import CardDetail from './Card/CardDetail';
import Notification from './Notification';
import AllRewards from './AllRewards';
import NewFeature from './NewFeature';
import Settings from './Settings';
import AdminBusinesses from './AdminBusinesses';
import BusinessPortal from './Business';

export class DashboardRoutes extends React.Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
    role: PropTypes.string,
  };

  componentDidMount() {
    const {
      location: { pathname },
    } = this.props;
    if (pathname === '/dashboard' || pathname === '/dashboard/') {
      this.getHomeComponent();
    }
  }

  getHomeComponent = () => {
    const { role } = this.props;
    if (role === 'Business') {
      replace('/dashboard/business');
    } else {
      replace('/dashboard/users');
    }
  };

  render() {
    const { isAuthenticated } = this.props;

    return (
      <>
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/users"
          component={User}
          exact
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/users/:id"
          component={UserDetail}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/card-list"
          component={Card}
          exact
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/card-list/:id"
          component={CardDetail}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/notifications"
          component={Notification}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/all-rewards"
          component={AllRewards}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/new-features-request"
          component={NewFeature}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/settings"
          component={Settings}
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/admin/businesses"
          component={AdminBusinesses}
          exact
        />
        <RoutePrivate
          isAuthenticated={isAuthenticated}
          path="/dashboard/business"
          component={BusinessPortal}
        />
      </>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    profile: state.auth.profile,
    role: state.auth.role,
  };
}

function mapDispatchToProps() {
  return {};
}

export default hot(connect(mapStateToProps, mapDispatchToProps)(DashboardRoutes));
